import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import GoogleDriveVideo from './CardVideo'

const HeroSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); 
    };

    handleResize(); 
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section id="home" className={`hero-section ${isMobile ? "reveal" : ""}`}>
      <Container fluid>
        <Row className="align-items-center min-vh-100">
          <Col lg={6} md={8} sm={12}>
            <div className="hero-overlay">
              {isMobile ? (
                <>
                  <h1 className="display-4 fw-bold mb-3">AMIGOS DO LIXO</h1>
                  <p className="lead mb-4">
                    O projeto Amigos do Lixo é uma iniciativa social e ambiental que atua na coleta seletiva e no reaproveitamento de materiais recicláveis em Guaratinguetá. 
                    Formado por uma cooperativa de catadores, o grupo promove a geração de renda, inclusão social e conscientização ambiental, 
                    contribuindo para uma cidade mais limpa, sustentável e justa.
                  </p>
                </>
              ) : (
                <p className="lead text-white mb-4">
                  <GoogleDriveVideo />
                </p>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
